import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const GoodCart = styled(Link)`
    position: relative;
    align-items: center;
    width: 100% ;
    height: 100%;
    text-decoration: none;
    display:flex;
    border-radius: var(--border-radius-9);
    box-shadow: var(--shadow-21);
    &.noborder{
        border: none;
        box-shadow: none;
    }
    .stand{
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: var(--border-radius-9);
        transition: all 0.3s ease-in-out;
    }
    :hover{
        .stand {
            filter: saturate(160%);
        }
        .g-image {
            img {
                transform: scale(1.1);
            }
        }
    }
    .g-image{
        position: relative;
        display: block;
        aspect-ratio: 1;
        border-radius: var(--border-radius-9);
        color: var(--text-3);
        img{
            position: relative;
            width: 52.4% ;
            display: block;
            padding-top: 28%;
            margin: auto;
            object-fit: contain;
            transition: all 0.3s ease-in-out;
            transform-origin: bottom;
        }
    }
    .g-data{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding: 1rem 0.25rem 1rem 1rem;
        grid-column: 2 / 4;
        grid-row:1;
        .actions{
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            .act{
                display: flex;
                position: relative;
                padding: 0.2rem;
                width: 1.5rem;
                height: 1.5rem;
                margin-right: 0.5rem;
                svg{
                    fill:var(--gray-8)
                }
                &.red-like{
                    background: rgba(204, 33, 41, 0.1);
                    svg{
                        fill:var(--secondry-5);
                    }
                }
            }
        }
        .g-name{
            font-weight: 400;
            font-size: 0.75rem;
            color: var(--text-3);
            text-align: right;
            margin-top:1.25rem ;
        }
    }
    .g-info{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: calc(100% - 1.25rem);
        height: calc(30% - 1rem);
        padding:0.5rem 0.25rem 0.5rem 1rem;
        grid-column: 2 / 4;
        grid-row: 2;
        .g-brand{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: end;
            .detail{
                font-weight: 400;
                font-size: 0.75rem;
                display: flex;
                margin: 0.2rem 0;
                color: var(--gray-11);
                flex-direction: row;
                .icon{
                    width: 1rem;
                    height: 1rem;
                    margin-left: 0.25rem;
                }
            }
        }
        .g-price{
            color: var(--text-3);
            font-weight: 700;
            font-size: 0.87rem;
            text-align: left;
        }
    }
    .g-info2{
        display:none
    }
    
    @media screen and (max-width: 850px){
        &.height-g{
            max-height: 60%;
        }
        .g-image{
            img{
                width: 55%;
            }
        }        
    }
`

const GoodCartHomeV2Main = React.forwardRef((props, ref)=>{
    let data = props.data
    let modelClass = 'model'+data.G_TAG_MODEL
    return (
        <GoodCart 
            className={props.orderH + (props.standimg === '' ? ' noborder' : '') }
            ref={ref}
            key={props.keys}
            to={{pathname: encodeURI('/good/'+ data.G_CODE+'/' + data.G_URL+'/')}}
            index={props.index}
        >
            {
                props.standimg ?
                <img className={"stand " + modelClass} alt={"stand"} src={data.G_TAG_MODEL_IMG} />
                // <img className="stand" alt={"stand"} src={props.standimg} />
                :''
            }
            <div className="g-image">
                <img src={data.G_IMAGE} alt={data.G_NAME}/>
            </div>
        </GoodCart>
    )
})
export default GoodCartHomeV2Main
